import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getEmailSetting = createAction(
  "GET_EMAIL_SETTING",
  ({ payload }: SagaActionParams<Type.EmailSettingDto>) => ({
    payload,
    url: "/api/Setting/email",
  })
);
export const updateEmailSetting = createAction(
  "UPDATE_EMAIL_SETTING",
  ({ payload, body }: SagaActionParams<Type.EmailSettingDto>) => ({
    payload,
    url: "/api/Setting/email",
    body,
  })
);
export const testEmailSetting = createAction(
  "TEST_EMAIL_SETTING",
  ({ payload, body }: SagaActionParams<any>) => ({
    payload,
    url: "/api/Setting/test",
    body,
  })
);

const emailSettingsSaga = [
  takeLatest<any>(getEmailSetting.toString(), (p: SagaGenericParams<Type.EmailSettingDto>) => getSaga<Type.EmailSettingDto>(p)),
  takeLatest<any>(updateEmailSetting.toString(), (p: SagaGenericParams<Type.EmailSettingDto>) => putSaga<Type.EmailSettingDto>(p)),
  takeLatest<any>(testEmailSetting.toString(), (p: SagaGenericParams<any>) => postSaga<any>(p)),
];

export default emailSettingsSaga;
